// extracted by mini-css-extract-plugin
module.exports = {"page":"_5D_-RoGe","main":"_5D2D4DEr","profile":"_5Dbz9uEr","form":"_5D1-LQyO","link":"_5D2aehwl"};